// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close-z {\n  z-index: 9;\n}\n", "",{"version":3,"sources":["webpack://src/components/OrderPlaced/OrderPlaced.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ","sourcesContent":[".close-z {\n  z-index: 9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
